export default "__VITE_ASSET__DJpfoYrd__"